import { Channel } from '@smatchy/chat-client';

export class GetChatsAction {
  static readonly type = '[Messaging] GetChatsAction';

  constructor(public readonly archived = false) {}
}

export class SetLoadingChatAction {
  static readonly type = '[Messaging] SetLoadingChatAction';
}

export class GetChatAction {
  static readonly type = '[Messaging] GetChatAction';

  constructor(public readonly chatId: string) {}
}

export class GetChatLoadedAction {
  static readonly type = '[Messaging] GetChatLoadedAction';
}

export class LoadMoreMessagesAction {
  static readonly type = '[Messaging] LoadMoreMessagesAction';

  constructor(public readonly count = 50, public readonly chatId?: string) {}
}

export class JoinChatChannelAction {
  static readonly type = '[Messaging] JoinChatChannelAction';

  constructor(public readonly channel: Channel) {}
}

export class LeaveChatChannelAction {
  static readonly type = '[Messaging] LeaveChatChannelAction';
}

/** One of my outings, as a card (« Ton mélange », 31/10/2026). Rejects when it did not leave. */
export class ShareOutingAction {
  static readonly type = '[Messaging] ShareOutingAction';

  constructor(public readonly eventId: string) {}
}

export class SendMessageTextAction {
  static readonly type = '[Messaging] SendMessageTextAction';

  /** `replyToId`: the message this one answers, swiped or picked under a long press. */
  constructor(public readonly text: string, public readonly replyToId?: string) {}
}

export class HandleNotReadMessagesAction {
  static readonly type = '[Messaging] HandleNotReadMessagesAction';

  constructor(public readonly messageIds: string[]) {}
}

export class NewMessageReceivedAction {
  static readonly type = '[Messaging] NewMessageReceivedAction';
}

export class SyncArchivedChatViewAction {
  static readonly type = '[Messaging] SyncArchivedChatViewAction';

  constructor(public readonly chatId: string) {}
}

/** SMA-22: one reaction per person, see applyMessageReaction. */
export class ReactToMessageAction {
  static readonly type = '[Messaging] ReactToMessageAction';

  constructor(public readonly messageId: string, public readonly emoji: string) {}
}

/**
 * The box changed: says « I am typing » to the others when it holds words,
 * at most every TYPING_SAID_EVERY_MS (see who-is-typing.ts).
 */
export class SayTypingAction {
  static readonly type = '[Messaging] SayTypingAction';

  constructor(public readonly text: string | null | undefined) {}
}
